import { Language } from '@/utils/language';
import { WrittenContent } from './WrittenContent';

export type Liveblog = {
  id: string;
  type: 'liveblog';
  title: string;
  slug: string;
  image?: object;
  lastUpdates?: WrittenContent[];
  points: string[];
  language: Language;
  updatedAt: string;
};

export function isLiveblog(content: Liveblog): content is Liveblog {
  return content.type === 'liveblog';
}